/**
 * Copyright © Veeam Software Group GmbH.
 */

export enum Protocols {
    SMTP = 'smtp://',
    HTTPS = 'https://',
}
